var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.ratingWrapper},[_c('div',{class:_vm.$style.rating},_vm._l((5),function(i){
var _obj;
return _c('component-icon',{key:i,class:( _obj = {}, _obj[_vm.$style.item] = true, _obj[_vm.$style.active] = i <= _vm.rating, _obj ),attrs:{"path":_vm.icons.mdiStar}})}),1),_vm._v(" "),(_vm.ratingCount)?_c('div',{class:_vm.$style.ratingCount},[_vm._v(_vm._s(_vm.ratingCount))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }